import React from 'react'

function Footer() {
  return (
    <div className="col-12 text-center" id="contribute">
        All right reserved &copy; pranshunayak
    </div>
  )
}

export default Footer